<template>
    <modal title="Delete?" width="35" :showModal="showModal" @close-modal="closeModal">
        <div class="delete-illustration-wrapper text-center">
            <img src="@/assets/images/delete-illustration.png" alt="Delete illustration" class="img-fluid" />
            <small>
                You are about to delete this item. This action cannot be undone. Would you like to
                continue?</small>
        </div>
        <div class="actions">
            <button class="cancel-btn cursor-pointer" @click="closeModal">Cancel</button>

            <base-button text="Delete" @click="deleteItem" :loading="deletingItemLoading" />
        </div>
    </modal>
</template>

<script>
// import Modal from "@/components/partials/Modal/index";
export default {
    components: {
        // Modal,
    },
    props: {
        showModal: {
            type: Boolean,
            required: true,
            default: false,
        },
        itemToDelete: {
            type: Object,
        },
        refetch: {
            type: Function,
        }
    },
    data() {
        return {
            selectedModule: null,
            moduleOptions: [],
            deletingItemLoading: false
        };
    },
    methods: {
        closeModal() {
            this.$emit("close-modal");
        },
        async deleteItem() {
            this.deletingItemLoading = true
            try {
                await this.$_deletePricing(this.itemToDelete.id);
                this.refetch()
            } catch (error) {
                this.handleError(error);
            } finally {
                this.deletingItemLoading = false
            }
        },
    },
};
</script>

<style scoped>
.actions {
    display: flex;
    justify-content: space-between;
    padding: 1.5rem 0 1rem;
}

.actions button {
    padding: 0.25rem 0.75rem;
    border-radius: 3px;
}

.cancel-btn {
    color: #f57a4d;
}

.edit-btn {
    background: #f57a4d;
    color: #ffffff;
}

.delete-illustration-wrapper img {
    margin: 1rem auto;
    width: 4rem;
    height: auto;
}
</style>
